import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import EducacaoService from '../../../../../../services/contasEducacao-auth';
import { Link } from 'react-router-dom';
import '../../../../../../styles/diario.scss';



const FormBusca = (props) => {
    const [fonte, setFonte] = useState("");
    const [objeto, setObjeto] = useState("");
    const [dataIn, setDataIn] = useState("");
    const [dataFt, setDataFt] = useState("");



    const busca = async (query) => {
        if (query == "") {
            await props.fetchDespesas()
            setDataIn("")
            setFonte("")
            setDataFt("")
            setObjeto("")
        } else {
            var response = await EducacaoService.buscarDespesa(query)
            if (response.data.length >= 1) {
                props.setDespesas(response.data)
                props.setVazio(false)
                setDataIn("")
                setFonte("")
                setDataFt("")
                setObjeto("")
            } else {
                props.setVazio(true)
                setDataIn("")
                setFonte("")
                setDataFt("")
                setObjeto("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (dataIn) prepQuery = prepQuery + `&dataIn=${dataIn}`;
        if (dataFt) prepQuery = prepQuery + `&dataFt=${dataFt}`;
        if (fonte) prepQuery = prepQuery + `&fonte=${encodeURI(fonte)}`;
        if (objeto) prepQuery = prepQuery + `&objeto=${encodeURI(objeto)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Fonte">
                                <FloatingLabel
                                    label="Fonte"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="fonte"
                                        value={fonte}
                                        onChange={e => setFonte(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="dataInicial">
                                <FloatingLabel
                                    label="Data Inicial"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataIn"
                                        value={dataIn}
                                        onChange={e => setDataIn(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="dataFinal">
                                <FloatingLabel
                                    label="Data Final"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataFt"
                                        value={dataFt}
                                        onChange={e => setDataFt(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Fonte">
                                <FloatingLabel
                                    label="Objeto"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="objeto"
                                        value={objeto}
                                        onChange={e => setObjeto(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/educacao/despesas'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment >
    )
}

export default FormBusca
